import React from "react";

const Info = (props) => {
  const _width = props.width || 24;
  return (
    <svg
      id="icon-info"
      xmlns="http://www.w3.org/2000/svg"
      data-name="icon-info"
      viewBox="0 0 24 24"
      width={_width}
      {...props}
    >
      <path d="M12,24A12,12,0,1,0,0,12,12.013,12.013,0,0,0,12,24ZM12,5a1.5,1.5,0,1,1-1.5,1.5A1.5,1.5,0,0,1,12,5Zm-1,5h1a2,2,0,0,1,2,2v6a1,1,0,0,1-2,0V12H11a1,1,0,0,1,0-2Z" />
    </svg>
  );
};

export default Info;
